import { SettingsBackupRestore } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCreateCustomer, useSendCustomerDeleteNotification } from 'shared/mutations';
import { useService } from 'shared/providers';
import { useQueryCustomerLookupWithFilters } from 'shared/queries';
import { useAuthState } from 'shared/stores';
import { ContractRouteParams, CustomerLookup } from 'shared/types';

export function CustomerInfoWidgetDeleteButton() {
  const { masterCustomer, abgBrand } = useParams<ContractRouteParams>();
  const { appConfig } = useService();
  const { customers } = useQueryCustomerLookupWithFilters({
    channel: '',
    customerTier: '',
    abgBrand,
    masterCustomer,
  });
  const [customer, setCustomer] = useState<CustomerLookup | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const createCustomerMutation = useCreateCustomer('update');
  const notificationMutation = useSendCustomerDeleteNotification();
  const authState = useAuthState();

  useEffect(() => {
    if (!customer) {
      if (customers && customers.length > 0) {
        const rightCustomer = customers.find(
          c =>
            c.uniqueid.includes(`${masterCustomer}${abgBrand}`) &&
            c.brand === abgBrand &&
            c.abgmastercustomer === masterCustomer
        );
        if (rightCustomer && rightCustomer.brand === abgBrand && rightCustomer.abgmastercustomer === masterCustomer) {
          setCustomer(rightCustomer);
        }
      }
    }
  }, [customers, customer, setCustomer, abgBrand, masterCustomer]);

  if (!customer) {
    return null;
  }

  const deleteRestoreWorkflow = async (approved: boolean) => {
    customer.ismarkedfordeletion = 'FALSE';
    await createCustomerMutation.mutateAsync(customer);
    await notificationMutation.mutateAsync({
      customer: customer,
      template: approved ? (customer.isdeleted === 'FALSE' ? 'restore' : 'approve') : 'reject',
      userName:
        authState.get()?.user?.displayName || `${authState.get()?.user?.firstName} ${authState.get()?.user?.lastName}`,
      environment: appConfig.environment,
    });
    setLoading(false);
  };

  const onApprove = async () => {
    setLoading(true);
    const isMarkedForDeletion = customer.ismarkedfordeletion === 'TRUE';
    customer.isdeleted = isMarkedForDeletion ? 'TRUE' : 'FALSE';
    await deleteRestoreWorkflow(true);
  };

  const onReject = async () => {
    setLoading(true);
    await deleteRestoreWorkflow(false);
  };

  return (
    <>
      {(customer.ismarkedfordeletion === 'TRUE' || customer.isdeleted === 'TRUE') && (
        <Grid container item xs={2}>
          <Grid item xs={12}>
            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
              {customer.isdeleted === 'TRUE' ? '' : 'Delete'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {customer.isdeleted === 'FALSE' && (
              <Button onClick={onReject} disabled={loading} variant='contained' color='error' sx={{ marginRight: 1 }}>
                reject
              </Button>
            )}
            <Button onClick={onApprove} disabled={loading} variant='contained' color='success'>
              {customer.isdeleted === 'TRUE' ? (
                <>
                  <SettingsBackupRestore sx={{ marginRight: 1 }} />
                  <span>Restore</span>
                </>
              ) : (
                'Approve'
              )}
            </Button>
          </Grid>
        </Grid>
      )}
    </>
  );
}
